import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SIGNIN_ROUTE } from '../../routes/routes';

function PrivateRoute({ component: Component, ...rest }) {
  const { user } = useSelector((state) => {
    const { signInReducer } = state;
    return {
      user: signInReducer.user,
    };
  });

  const location = useLocation();

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              ...location,
              pathname: SIGNIN_ROUTE,
              from: location,
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
